"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var Child = function Child(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M3.24984 4.49967C4.40043 4.49967 5.33317 3.56693 5.33317 2.41634C5.33317 1.26575 4.40043 0.333008 3.24984 0.333008C2.09924 0.333008 1.1665 1.26575 1.1665 2.41634C1.1665 3.56693 2.09924 4.49967 3.24984 4.49967Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M4.5434 5.33301C4.44195 5.92124 3.88398 6.36242 3.27528 6.36242C2.66659 6.36242 2.10861 5.92124 2.00717 5.33301H0.333252V10.235H1.95644V13.6663H4.69557V10.235H6.16659V5.33301H4.5434Z",
    fill: "#75767A"
  }, colorStyles)));
};
Child.propTypes = _inline_svg2.default.propTypes;
Child.defaultProps = _inline_svg2.default.defaultProps;
var _default = Child;
exports.default = _default;